// src/components/RegisteredHeroText.js
import React from "react";
import LearnersOverview from "../parent/LearnersOverview";
import OnboardingSteps from "./OnboardingSteps";
import styles from "./styles/RegisteredLandingLayout.module.css";

export default function RegisteredHeroText({
  firstName,
  hasLearners,
  learners,
  router,
  onAddLearner,
  onBrowseClasses,
  onMyClasses,
}) {
  // If no learners, show onboarding
  if (!hasLearners) {
    return (
      <div className={styles.heroText}>
        <p className={styles.kicker}>Welcome, {firstName}</p>

        <h1 className={styles.h1}>
          Hi {firstName}, let&apos;s get your child ready to learn.
        </h1>

        <p className={styles.heroSub}>
          You&apos;ve created your PenguinLearn parent account — now add your
          learner&apos;s details and pick their first live class.
        </p>

        <OnboardingSteps
          onAddLearner={onAddLearner}
          onBrowseClasses={onBrowseClasses}
          onMyClasses={onMyClasses}
        />
      </div>
    );
  }

  return (
    <div className={styles.heroText}>
      <p className={styles.kicker}>Welcome back, {firstName}</p>
      <LearnersOverview learners={learners} router={router} />
    </div>
  );
}